<template>
    <modal
        transition="nice-modal-fade"
        class="new-modal-default lead-interaction-add-product"
        :class="{'lead-interaction-add-product-edit':edit_mode == true}"
        :name="modal_name"
        :delay="100"
        height="auto"
        :adaptive="true" 
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false">
        <div class="v-modal-content" style="border-radius: 15px;background-color: #fff !important;">
            <!-- Header Section -->
            <div class="v-modal-header">
                <div>
                    <span v-if="edit_product == true" class="v-modal-dialog-title v-modal-title text-uppercase">Edit Products</span>
                    <span v-if="edit_product == false" class="v-modal-dialog-title v-modal-title text-uppercase">Add Products</span>
                </div>
                <div v-if="edit_product == true" @click="hideAddProductModal()">
                    <span class="icon icon-close mr-2 text-white pointer close-left"></span>
                </div>
                <div v-else @click="closeLeadProducts()">
                    <span class="icon icon-close mr-2 text-white pointer close-left"></span>
                </div>
            </div>
            <!-- Content Body Section -->
            <div class="v-modal-body">
                <div class="fs-14 fw-500 p-2 bg-color mb-6">Products Details</div>
                <!-- <div v-if="edit_product == false" class="fs-14 fw-500 p-2 bg-color mb-6">Add Products</div> -->
                <div class="position-relative ml-1 mr-1">
                    <div class="product-box mt-3" v-for="(product, product_index) in products_data" :key="product_index">
                        <div class="row">
                            <span v-if="products_data.length > 1 && edit_product == false" class="position-absolute pointer minus-icon" style="margin-top: -5px;right: 2px;z-index:1" @click="removeProductNew(product_index)">
                                <i class="icon icon-minus-circle text-danger fs-25"></i>
                            </span>
                            <span v-if="edit_product == true" class="position-absolute pointer minus-icon" style="margin-top: -5px;right: 2px;z-index:1" @click="confirmDeleteProduct(product)">
                                <i class="icon icon-minus-circle text-danger fs-25"></i>
                            </span>
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                                <span class="fs-14 fw-600 px-2 text-secondary">
                                    Product<sup class="fs-14 pl-1 text-danger">*</sup>
                                </span>
                                <div class="d-flex align-items-center">
                                    <div class="w-100">
                                        <multiselect :disabled="edit_product"
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                            placeholder="Select Product" v-validate="{required:true}"
                                            label="name" open-direction="bottom" :name="'product_name'+product_index"
                                            v-model="product.product_name" @open="resetData('name', product_index)"
                                            :options="products_options" track-by="name"
                                            @select="getProductData($event, product_index)"
                                            :multiple="false" :searchable="true" :internal-search="true"
                                            :clear-on-select="false" :close-on-select="true" :options-limit="3000" :show-no-results="true" :hide-selected="false"
                                            :blockKeys="['Delete']" :limit="1" :limit-text="limitProduct" :loading="products_loading && clicked_dd == product_index" @search-change="searchProuctName"
                                        >
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag">
                                                <span class="filterSelectedName">{{ option.name }}</span>
                                                </span>
                                            </template>
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfProductName" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center font-weight-bold" >Product Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <span class="text-danger mt-1" v-show="errors.has('product_name'+product_index)">
                                    Product Name is Required
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                                <span class="fs-14 fw-600 px-4 text-secondary">Quantity<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                <div class="d-flex align-items-center">
                                    <input :name="'amount_inquired'+product_index" class="inputFieldNew mt-2" v-on:keypress="isNumber($event), evaluvateData(product_index, 'inquired')" :maxLength="15" autocomplete="off" type="text" v-validate="{ required: true, regex: /^-?\d+(?:\.\d?\d)?$/}" v-model="product.amount_inquired" placeholder="Enter Amount Inquired" />
                                </div>
                                <span v-if="product.amount_inquired == '' && errors.has('amount_inquired'+product_index)" class="text-danger mt-1">
                                    Quantity is Required
                                </span>
                                <span v-else-if="product.amount_inquired == '0.'" class="text-danger mt-1">
                                    Invalid Quantity
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                                <span class="fs-14 fw-600 px-4 text-secondary">Transaction Value Per Unit ({{currency}})<sup class="fs-14 pl-1 text-danger">*</sup></span>
                                <div class="d-flex align-items-center">
                                    <input :name="'price_quoted'+product_index" class="inputFieldNew mt-2" v-on:keypress="isNumber($event), evaluvateData(product_index, 'quoted')" :maxLength="15" type="text" autocomplete="off" v-validate="{ required: true, regex: /^-?\d+(?:\.\d?\d)?$/}" v-model="product.price_quoted" placeholder="Enter Amount Quoted" />
                                </div>
                                <span v-if="product.price_quoted == '' && errors.has('price_quoted'+product_index)" class="text-danger mt-1">
                                    Transaction Value Per Unit is Required
                                </span>
                                <span v-else-if="product.price_quoted == '0.'" class="text-danger mt-1">
                                    Invalid Amount Quoted
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-5" v-for="(sales, sales_index) in product.template_fields.fields" :key="sales_index">
                                    <div v-if="sales.field_type == 'input_field' && sales.is_required == false">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize" >
                                            {{sales.field_name}}
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100"> 
                                                <input class="inputFieldNew mt-2" :maxlength="50" type="text" v-model="sales.value" :placeholder="'Enter ' + sales.field_name" />
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="sales.field_type == 'dropdown_field' && sales.is_required == false">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <multiselect
                                                    class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                                    name="voltage_applicable" :searchable="true" open-direction="bottom"
                                                    v-model="sales.value" :max-height="200" label="" id="ajaxnew" @change="$forceUpdate()"
                                                    :options="sales.options" :placeholder="'Select ' + sales.field_name" />
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">{{sales.field_name}} Not Found</div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="sales.field_type == 'amount' && sales.is_required == false">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}({{currency}})
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <input class="inputFieldNew mt-2" v-on:keypress="isNumber($event)" :maxLength="15" autocomplete="off" type="text"  v-model="sales.value" placeholder="Enter Amount" />
                                                <!-- <input class="inputFieldNew mt-2" maxlength="20" type="text" v-model.number="sales.value" :placeholder="'Enter' + sales.field_name" /> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="sales.field_type == 'checkbox' && sales.is_required == false">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}
                                        </span>
                                        <div class="d-flex justify-content-between align-items-center px-2">
                                            <el-checkbox-group class="refund-checkbox mt-4 w-100" v-model="sales.value">
                                                <div class="row">
                                                     <el-checkbox @change="$forceUpdate()" class="col-xl-4 col-lg-6 col-md-6 col-sm-6 w-150 text-capitalize d-flex word-wrap text-truncate" :title="check" :label="check" v-for="(check, option_index) in sales.options" :key="option_index">
                                                          {{check}}
                                                     </el-checkbox>
                                                </div>
                                           </el-checkbox-group>
                                            <!-- <div class="form-check form-check-inline mr-0 mb-1" v-for="(check, option_index) in sales.options" :key="option_index+'option_index'" style="width: 140px;">
                                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                    <input type="checkbox" class="custom-control-input" :value="check" v-model="check.value" @change="insertCheckboxValue($event, product_index, sales_index, check)" :checked="check.checked"/>
                                                    <span class="custom-control-indicator" style="font-size: 20px; top: -8px !important;"></span>
                                                    <span class="form-check-description fw-600"></span>
                                                </label>
                                                <span class="text-secondary fs-14 fw-600 mr-2 text-truncate" :title="check">{{check}}</span>
                                            </div> -->
                                        </div>
                                    </div>
                                    <div v-if="sales.field_type == 'date_and_time' && sales.is_required == false">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="row">
                                                <div class="col-lg-7 col-md-6 col-sm-12 mt-2">
                                                    <div class="w-100">
                                                        <date-picker @change="$forceUpdate()"
                                                            class="meetinfdatetime calendar-edit-per calendar-edit-per-margin deal-date mx-left mr-1"
                                                            v-model="sales.date_value" value-type="format"lang="en" type="date" format="MM-DD-YYYY">
                                                        </date-picker>
                                                    </div>
                                                </div>
                                                <div class="col-lg-5 col-md-6 col-sm-12 mt-2 margin-top-res">
                                                    <div class="w-100">
                                                        <date-picker v-model="sales.time_value" name="time" @change="$forceUpdate()"
                                                            class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                                            format="hh:mm A" type="time" placeholder="Select Time" value-type="format"
                                                            lang="en" :clearable="false" :editable="false" :minute-step="1" confirm
                                                            confirm-text="APPLY">
                                                        </date-picker>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="sales.field_type == 'date' && sales.is_required == false">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <date-picker
                                                    class="cal-icon date-input-customer calendar-edit-per input-field pt-0 pb-0 pr-0 mt-2"
                                                    v-model="sales.value" value-type="format" lang="en" type="date"
                                                    @change="$forceUpdate()" format="MM-DD-YYYY" :clearable="false">
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="sales.field_type == 'radio_button' && sales.is_required == false">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100 mt-2">
                                                <el-radio-group v-model="sales.value" v-for="(option,option_index) in sales.options"
                                                    :key="option_index" class="w-200px">
                                                    <el-radio class="ml-2 pt-2" @change="$forceUpdate()"
                                                        :label="option" :id="option">{{option}}</el-radio>
                                                </el-radio-group>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="sales.field_type == 'time' && sales.is_required == false">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <date-picker v-model="sales.value" name="time" @change="$forceUpdate()"
                                                    class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                                    format="hh:mm A" type="time" placeholder="Select Time" value-type="format"
                                                    lang="en" :clearable="false" :editable="false" :minute-step="1" confirm
                                                    confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="sales.field_type == 'input_field' && sales.is_required == true">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize" >
                                            {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <input class="inputFieldNew mt-2" :maxlength="50" v-validate="{required:true}" :name="'sales_field'+sales_index" type="text" v-model="sales.value" :placeholder="'Enter ' + sales.field_name" />
                                            </div>
                                        </div>
                                        <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                            {{sales.field_name}} is Required
                                        </span>
                                    </div>
                                    <div v-if="sales.field_type == 'dropdown_field' && sales.is_required == true">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <multiselect v-validate="{required:true}" :name="'sales_field'+sales_index"
                                                    class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                                    :searchable="true" open-direction="bottom" @change="$forceUpdate()"
                                                    v-model="sales.value" :max-height="200" label="" id="ajaxnew"
                                                    :options="sales.options" :placeholder="'Select ' + sales.field_name" />
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">{{sales.field_name}} Not Found</div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                        <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                            {{sales.field_name}} is Required
                                        </span>
                                    </div>
                                    <div v-if="sales.field_type == 'amount' && sales.is_required == true">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}({{currency}})<sup class="fs-14 pl-1 text-danger">*</sup>
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <input :name="'sales_field'+sales_index" class="inputFieldNew mt-2" v-on:keypress="isNumber($event)" :maxLength="15" autocomplete="off" type="text" v-validate="{ required: true, regex: /^-?\d+(?:\.\d?\d)?$/}" v-model="sales.value" placeholder="Enter Amount" />
                                                <!-- <input class="inputFieldNew mt-2" v-validate="{required:true}" :name="'sales_field'+sales_index" type="text" v-model.number="sales.value" :placeholder="'Enter ' + sales.field_name" /> -->
                                            </div>
                                        </div>
                                        <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                            {{sales.field_name}} is Required
                                        </span>
                                    </div>
                                    <div v-if="sales.field_type == 'checkbox' && sales.is_required == true">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                        </span>
                                        <div class="d-flex justify-content-between align-items-center px-2">
                                            <el-checkbox-group class="refund-checkbox mt-4 w-100" v-validate="'required'" :name="'sales_field'+sales_index" v-model="sales.value">
                                                <div class="row">
                                                     <el-checkbox @change="$forceUpdate()" class="col-xl-4 col-lg-6 col-md-6 col-sm-6 w-150 text-capitalize d-flex word-wrap text-truncate" :title="check" :label="check" v-for="(check, option_index) in sales.options" :key="option_index">
                                                          {{check}}
                                                     </el-checkbox>
                                                </div>
                                           </el-checkbox-group>
                                            <!-- <div class="form-check form-check-inline mr-0 mb-1" v-for="(check, option_index) in sales.options" :key="option_index+'option_index'" style="width: 140px;">
                                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                    <input type="checkbox" class="custom-control-input" v-validate="{required:true}" :name="'sales_field'+sales_index" :value="check" v-model="check.value" @change="insertCheckboxValue($event, product_index, sales_index, check)" :checked="check.checked"/>
                                                    <span class="custom-control-indicator" style="font-size: 20px; top: -8px !important;"></span>
                                                    <span class="form-check-description fw-600"></span>
                                                </label>
                                                <span class="text-secondary fs-14 fw-600 mr-2">{{sales.options[option_index]}}</span>
                                            </div> -->
                                        </div>
                                        <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                            {{sales.field_name}} is Required
                                        </span>
                                    </div>
                                    <div v-if="sales.field_type == 'date_and_time' && sales.is_required == true">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="row">
                                                <div class="col-lg-7 col-md-6 col-sm-12 mt-2">
                                                    <div class="w-100">
                                                        <date-picker v-validate="{required:true}" :name="'sales_field'+sales_index" @change="$forceUpdate()"
                                                            class="meetinfdatetime calendar-edit-per calendar-edit-per-margin deal-date mx-left mr-1"
                                                            v-model="sales.date_value" value-type="format" lang="en" type="date" format="MM-DD-YYYY">
                                                        </date-picker>
                                                    </div>
                                                </div>
                                                <div class="col-lg-5 col-md-6 col-sm-12 mt-2 margin-top-res">
                                                    <div class="w-100">
                                                        <date-picker v-model="sales.time_value" v-validate="{required:true}" :name="'sales_field'+sales_index"
                                                            class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                                            format="hh:mm A" type="time" placeholder="Select Time" value-type="format" @change="$forceUpdate()"
                                                            lang="en" :clearable="false" :editable="false" :minute-step="1" confirm
                                                            confirm-text="APPLY">
                                                        </date-picker>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                            {{sales.field_name}} is Required
                                        </span>
                                    </div>
                                    <div v-if="sales.field_type == 'date' && sales.is_required == true">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <date-picker v-validate="{required:true}" :name="'sales_field'+sales_index"
                                                    class="cal-icon date-input-customer calendar-edit-per input-field pt-0 pb-0 pr-0 mt-2"
                                                    v-model="sales.value" value-type="format" lang="en" type="date"
                                                    @change="$forceUpdate()" format="MM-DD-YYYY" :clearable="false">
                                                </date-picker>
                                            </div>
                                        </div>
                                        <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                            {{sales.field_name}} is Required
                                        </span>
                                    </div>
                                    <div v-if="sales.field_type == 'radio_button' && sales.is_required == true">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100 mt-2">
                                                <el-radio-group v-model="sales.value" v-validate="'required'" :name="'sales_field'+sales_index" v-for="(option,option_index) in sales.options"
                                                    :key="option_index" class="w-200px">
                                                    <el-radio class="ml-2 pt-2" @change="$forceUpdate()"
                                                        :label="option" :id="option">{{option}}</el-radio>
                                                </el-radio-group>
                                            </div>
                                        </div>
                                        <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                            {{sales.field_name}} is Required
                                        </span>
                                    </div>
                                    <div v-if="sales.field_type == 'time' && sales.is_required == true">
                                        <span class="fs-14 fw-600 px-2 text-secondary text-capitalize">
                                            {{sales.field_name}}<sup class="fs-14 pl-1 text-danger">*</sup>
                                        </span>
                                        <div class="d-flex align-items-center">
                                            <div class="w-100">
                                                <date-picker v-model="sales.value" v-validate="{required:true}" :name="'sales_field'+sales_index"
                                                    class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                                    format="hh:mm A" type="time" placeholder="Select Time" value-type="format" @change="$forceUpdate()"
                                                    lang="en" :clearable="false" :editable="false" :minute-step="1" confirm
                                                    confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                        </div>
                                        <span class="text-danger mt-1" v-show="errors.has('sales_field'+sales_index)">
                                            {{sales.field_name}} is Required
                                        </span>
                                    </div>
                            </div>
                        </div>
                        <div v-if="edit_product == true" class="pointer" style="text-align: end;">
                            <button class="mt-2 ml-4 mr-2 btn-edit-save" :disabled="disableButtonAndDisplayLoader == true " :class="{'disableBtn' :disableButtonAndDisplayLoader == true}" @click="EditProduct(product)">Save</button>
                            <!-- <button class="mt-2 mr-2 btn-edit-delete-style" :disabled="disableButtonAndDisplayLoader == true" :class="{'disableBtn' :disableButtonAndDisplayLoader == true}" @click="confirmDeleteProduct(product)">Delete</button> -->
                        </div>
                    </div>
                    <div class="pt-3 pb-1" style="text-align: end;" v-if="!edit_product">
                        <button class="btn btn-secondary text-capitalize ml-4" @click="addProductNew()" style="border-radius: 8px !important;">
                            <!-- <i class="icon icon-plus-circle-outline fs-18 text-white"></i> -->
                            + Add Product
                        </button>
                    </div>
                </div>
            </div>
            <!-- Buttons Section -->
            <div class="v-modal-footer mb-4 mt-2" v-if="edit_product == false">
                <div v-if="disableButtonAndDisplayLoader == false" class="d-flex  align-items-center justify-content-center ">
                    <button class="btn new-cancel-button mt-2" @click="closeLeadProducts()">Cancel</button>
                    <button class="btn new-save-button mt-2 ml-6" @click="validateData()">Save</button>
                </div>
                <div v-else class="d-flex  align-items-center justify-content-center">
                    <button class="btn btn-des-small mt-2 btn-cancel-style" style="border: 1px solid transparent;color: #A6A6A6 !important;" disabled>Cancel</button>
                    <button class="btn btn-des-small mt-2 ml-6 btn-new-save" style="border: 1px solid transparent;position: relative;" disabled>Save
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
    </modal>
</template>
<script>
import { HollowDotsSpinner } from "epic-spinners";
import deals from "../mixins/deals";
import leads from "../mixins/leads";
import { SweetModal } from 'sweet-modal-vue';
import { debounce } from 'lodash';
import productslist from '../mixins/products';
export default {
    data(){
        return {
            products_options: [],
            selected_field: '',
            updateInProgress: false,
            disableButtonAndDisplayLoader: false,
            products: [{
                product_name: "",
                template_fields: {},
                amount_inquired: "",
                price_quoted: "",
                // products_loading: false,
            }],
            selected_product_index: null,
            temp_selected_products: [],
            products_count: 0,
            products_scrollable :false,
            products_visible: false,
            temp_products: [],
            search_key: '',
            success_msg: "",
            warning_msg: "",
            currency: "",
            edit_mode: false,
            products_data: [{
                product_name: '', 
                template_fields: {},
                // template: '',
                // voltage_applicable: '',
                // specification:'',
                // tap_changer: '',
                price_quoted: '',
                amount_inquired:''
            }],
            template_options: [],
            voltage_applicable_options:[],
            tap_changer_options: [],
            products_loading: false,
            skip: 0,
            template_fields: {},
            clicked_dd: 0,
            temp_sales_fields: [],
            stringified_bus_response: "",
            template_loader: false,
            template_details: {}
        }
    },
    props: ['modal_name', 'edit_lead_products','lead_products','selected_lead_id', "edit_product", "single_product"],
    components: {SweetModal, HollowDotsSpinner},
    mixins: [deals, leads, productslist],
    methods: {
        insertCheckboxValue(event, pr_index, temp_index, data){
            if(this.products_data[pr_index].template_fields[temp_index].value.indexOf(data) != -1){
                let data_index = this.products_data[pr_index].template_fields[temp_index].value.indexOf(data)
                this.products_data[pr_index].template_fields[temp_index].value.splice(temp_index, 1)
            }else{
                this.products_data[pr_index].template_fields[temp_index].value.push(data)
            }
            this.$forceUpdate();
        },
        async getProductData(data, index){
            this.products_data[index].template_fields = {}
            let params = {
                _id: data._id,
                edit: true
            }
            let response = await this.GetProductByID(params)
            let sales_template_details_data = response.response.result
            if(sales_template_details_data.sales_template_details == null){
                this.template_loader = false
            }else{
                let data_temp = sales_template_details_data.sales_template_details
                let fields_data = data_temp.fields
                this.template_details._id = sales_template_details_data.sales_template_id
                this.template_details.fields = fields_data
                this.template_details.fields.forEach(x => {
                    if(x.field_type == 'checkbox'){
                        x['value']= []
                    }else if(x.field_type == 'date_and_time'){
                        x['time_value']= ""
                        x['date_value']= ""
                    }else{
                        x['value'] = null
                    }
                })
                this.products_data[index].template_fields =  this.template_details
            }
            // let response = await this.GetProductByID(params)
            // let sales_template_details_data = response.response.result
            // let sales_data_details = sales_template_details_data.sales_template_details.fields
            // sales_data_details.forEach(x => {
            //     if(x.field_type == 'checkbox'){
            //         x['value']= []
            //     }else{
            //         x['value'] = null
            //     }
            // })
            // this.products_data[index].template_fields = sales_data_details
            // this.products_data.forEach((el,index)=>{
            //     el.voltage_applicable = 'data2',
            //     el.specification = 'data1',
            //     el.tap_changer = '100',
            //     el.price_quoted = '1001',
            //     el.amount_inquired= '10023'
            // })
        },
        removeProductName(option){
            this.product.product_name.forEach((el,index)=>{
                if(el == option){
                    this.product.product_name.splice(index,1)
                }
            })
        },
        limitProduct(count) {
			return `+ ${count} more`
        },
        resetData(type, index){
            this.clicked_dd = index    
            this.selected_field = type
            this.products_options = [];
            this.products_count = 0;
        },
        async searchProuctNameDebouncer(search){
            this.products_loading = true
            this.products_count = 0
            let params = {
                skip: this.skip,
                limit: 10,
                search_key: search,
                sort_key: "name",
                sort_value: 1,
                category_ids:[],
                sub_category_ids:[],
                product_type_ids:[],
                product_ids:[],
                brand_ids:[],
                outlet_ids:[],
                status:[],  
                visibility:"Manufacturing"
            }
            let response = await this.ProductsList(params)
            this.products_options = response.response.result
            if(this.lead_products.length > 0){
                this.products_options.forEach((x, index) =>{
                    this.lead_products.forEach((y, y_index) =>{
                        if(x._id == y.product_id){
                            this.products_options.splice(index,1)
                        }
                    })
                })
            }
            if(this.products_data.length > 0){
                this.products_options.forEach((x, index) =>{
                    this.products_data.forEach((y, y_index) =>{
                        if(x._id == y.product_name._id){
                            this.products_options.splice(index,1)
                        }
                    })
                })
            }
            this.products_count = this.products_options.length
            this.products_loading = false
        },
        async reachedEndOfProductName(reached){
            if(reached){
                if(this.products_scrollable == false){
                    this.products_loading = true
                    let response = await this.ProductsList({
                        skip: this.products_count,
                        limit: 10,
                        search_key: '',
                        sort_key: "name",
                        sort_value: 1,
                        category_ids:[],
                        sub_category_ids:[],
                        product_type_ids:[],
                        product_ids:[],
                        brand_ids:[],
                        outlet_ids:[],
                        status:[],  
                        visibility:"Manufacturing"
                    } )
                    let temp_products_options = response.response.result.length;
                    if(response.response.filter_data.skip == this.products_count){
                        if(temp_products_options > 0){
                            let tempfiles = response.response.result
                            // tempfiles.forEach(el => {
                            //     if(el[this.selected_field] != '' && el.hasOwnProperty(this.selected_field)){
                            //         this.products_options.push(el)
                            //     }
                            // })
                            // let uniqueArray = this.products_options.filter((value, index_dd) => {
                            //     const _value = value[this.selected_field];
                            //     return index_dd === this.products_options.findIndex(obj => {
                            //         return obj[this.selected_field] === _value;
                            //     });
                            // });
                            this.products_options = tempfiles
                            if(this.lead_products.length > 0){
                                this.products_options.forEach((x, index) =>{
                                    this.lead_products.forEach((y, y_index) =>{
                                        if(x._id == y.product_id){
                                            this.products_options.splice(index,1)
                                        }
                                    })
                                })
                            }
                            if(this.products_data.length > 0){
                                this.products_options.forEach((x, index) =>{
                                    this.products_data.forEach((y, y_index) =>{
                                        if(x._id == y.product_name._id){
                                            this.products_options.splice(index,1)
                                        }
                                    })
                                })
                            }
                            this.products_count += response.response.result.length;
                            this.products_loading = false
                        } else {
                            this.products_scrollable = true
                            this.products_loading = false
                        }
                        this.products_scrollable = false
                    }
                }
            }
        },
        addProductNew() {
            this.products_data.push({
                product_name: '', 
                template_fields: {},
                // template: '',
                // voltage_applicable: '',
                // specification:'',
                // tap_changer: '',
                price_quoted:'',
                amount_inquired:''
            })
        },
        removeProductNew(index){
            this.products_data.splice(index, 1)
        },
        // selecterProductList(product){
        //     this.temp_selected_products.push({
        //         product_id: product.id
        //     })
        // },
        //Restricts dot and zero as first inputs 
        evaluvateData(index, amount){
            this.products.forEach((el, el_index) => {
                if(index === el_index){
                    if(amount == 'quoted'){
                        if(el.value.startsWith(".")){
                            this.products_data[index].value = "0" + el.value
                        }
                    } else if(amount === 'inquired'){
                        if(el.value.startsWith(".")){
                            this.products_data[index].value = "0" + el.value
                        }
                    }
                }
            })
        },
        //Validates input data is number or not
        isNumber: (evt) =>  {
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
                evt.preventDefault();
            else {
                var index = evt.target.value.indexOf('.');
                if(index == 0){
                    if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 8)){
                        evt.preventDefault();
                    } else {
                        let number = evt.target.value.split('.')
                        if(number[1].length > 1){
                            evt.preventDefault();
                        }
                    }
                }
                else if (index > 0 && charCode == 46) {
                    evt.preventDefault();
                }
                if (index > 0) {
                    let number = evt.target.value.split('.')
                    if(number[1].length > 1){
                        evt.preventDefault();
                    }
                }
            }
        },
        //API call to load forst 10 products
        async loadLeadProducts(){
            let type = localStorage.getItem("leads_type")
            let res
            if(type == 'Manual'){
                res = await this.getLeadProducts(this.$route.params.id)
            } else if(type == 'Archive'){
                res = await this.getArchiveLeadProducts(this.$route.params.id)
            } else if(type == 'Converted'){
                res = await this.getConvertedLeadProducts(this.$route.params.id)
            }
            this.products = res.response
            let selected_products = []
            this.products.forEach(el =>{
                selected_products.push({
                    amount_inquired: el.amount_inquired,
                    price_quoted: el.price_quoted,
                    product_name: {
                        id : el.product_id,
                        name : el.product_name,
                    },
                    template_fields: el.template_details
                    // {
                    //     template_id: "",
                    //     template_name: "",
                    //     template_fields: el.template_fields
                    // }
                })
            })
            this.products_data = selected_products
            setTimeout(() => {
                if(this.edit_product == true && this.products_data.length == 0){
                    this.hideAddProductModal();
                }
            }, 2500);
            this.stringified_bus_response = JSON.stringify(this.created_product_data)
        },
        //API call to save edited data
        async EditProduct(product){
            let selected_products = []
            this.disableButtonAndDisplayLoader = true;
            // this.products_data.forEach(el =>{
            //     selected_products.push({
            //         amount_inquired: 0,
            //         price_quoted: 0,
            //         product_id: el.product_name._id ? el.product_name._id : el.product_name.id,
            //         product_name: el.product_name.name,
            //         template_info: el.template_fields
            //     })
            // })
            try{
                let params = {
                    amount_inquired: product.amount_inquired,
                    price_quoted: product.price_quoted,
                    product_id: product.product_name._id ? product.product_name._id : product.product_name.id,
                    product_name: product.product_name.name,
                    template_info: product.template_fields
                }
                // let params = {
                //     lead_id: this.$route.params.id ? this.$route.params.id : this.selected_lead_id,
                //     products:selected_products,
                // }
                let response = await this.editLeadProductByID(this.$route.params.id, params)
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.success_modal.close();
                        if(this.single_product == false){
                            this.loadLeadProducts();
                        }else if(this.single_product == true) {
                            this.hideAddProductModal();
                        }
                    }, 3000);
                } else {
                    this.warning_msg = response.message
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }catch(error){
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.disableButtonAndDisplayLoader = false;
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        //Alert popup to confirm delete product
        confirmDeleteProduct(product){
            this.$swal({
                title: "Delete Product!",
                text: "Do you want to delete selected Product ?",
                type: "warning",
                confirmButtonText: "Yes",
                showCancelButton: true,
                cancelButtonText: "No",
                confirmButtonColor: "#00448b",
            }).then(result => {
                if (result.value) {
                    this.removeEditedProduct(product)
                }
            });
        },
        //API call to delete product
        async removeEditedProduct(product){
            this.updateInProgress = true;
            try{
                let lead_id = this.$route.params.id
                let params = {
                    product_id: product.product_name.id,
                    product_name: product.product_name.name
                }
                let response = await this.deleteLeadProductByID(lead_id, params)
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.updateInProgress = false;
                        this.$refs.success_modal.close();
                        this.loadLeadProducts();
                        if(this.product.length == 0){
                            this.closeLeadProducts();
                        }else{
                            this.loadLeadProducts();
                        }
                    }, 3000);
                } else {
                    this.warning_msg = response.message
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.updateInProgress = false;
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }catch(error){
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.updateInProgress = false;
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        validateData(){
            this.$validator.validateAll().then(result =>{
                if(result){
                    this.saveProductData();
                }
            });
        },
        //API call to save products
        async saveProductData(){
            this.disableButtonAndDisplayLoader = true;
            // this.products_data.forEach(x => {
            //     x.template_fields.forEach(y => {
            //         if (y.value && typeof y.value === 'object') {
            //             this.temp_sales_fields.push({
            //                 // id: x._id,
            //                 "Transformer Type": y.field_name,
            //                 "Transformer Volt": y.value.value
            //             })
            //         } 
            //         // else if (y.value && typeof y.value !== 'object') {
            //         //     this.temp_sales_fields.push({
            //         //         // id: x._id,
            //         //         "Transformer Type": y.field_name,
            //         //         "Transformer Volt": y.value
            //         //     })
            //         // }

            //     })
            // })
            let selected_products = []
            this.products_data.forEach(el =>{
                selected_products.push({
                    amount_inquired: el.amount_inquired,
                    price_quoted: el.price_quoted,
                    product_id: el.product_name._id ? el.product_name._id : el.product_name.id,
                    product_name: el.product_name.name,
                    template_info: el.template_fields
                    // {
                    //     template_id: "",
                    //     template_name: "",
                    //     template_fields: el.template_fields
                    // }
                })
            })
            
            
            try{
                let params = {
                    lead_id: this.$route.params.id ? this.$route.params.id : this.selected_lead_id,
                    products:selected_products
                    // specification:this.products_data.specification,
                    // voltage_applicable:this.products_data.voltage_applicable,
                    // tap_changer:this.products_data.tap_changer,
                    // template_info: {
                    // template_id: "620ba02ee06c24c8ad4c4438",
                    // template_name: "Template 101",
                    // template_fields: {
                    //     "Transformer Type": "Electric",
                    //     "Transformer Volt": "67v"
                    // }
                    // }
                }
                // let lead_id = this.$route.params.id
                // let params_edit = {
                //     amount_inquired: 0,
                //     price_quoted: 0,
                //     product_id: selected_products.product_id,
                //     product_name: selected_products.product_name,
                //     template_info: selected_products.template_info
                // }\
                let response = await this.addProductsToActiveLead(params)
                if (response.status_id == 1) {
                this.success_msg = response.message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.disableButtonAndDisplayLoader = false;
                    this.$refs.success_modal.close();
                    this.hideAddProductModal();
                }, 3000);
            } else {
                this.warning_msg = response.message
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.disableButtonAndDisplayLoader = false;
                    this.$refs.warning_modal.close();
                }, 3000);
            }
            }catch(error){
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.disableButtonAndDisplayLoader = false;
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        hideAddProductModal(){
            this.$modal.hide(this.modal_name)
            this.$emit('hideAddProductModal')
        },
        closeLeadProducts(){
            this.$modal.hide(this.modal_name)
            this.$emit('closeLeadProducts')
        },
        addProducts(){
            this.products.push({
                product_name: "",
                amount_inquired: "",
                price_quoted: "",
                // products_loading: false,
            });
        },
        removeProduct(index, product){
            this.products.splice(index, 1)
            // this.temp_selected_products.forEach((del_product, del_index) => {
            //     if(del_product.product_id === product.product_name.id){
            //         this.temp_selected_products.splice(del_index, 1)
            //     }
            // })
        },
        closeSearchProduct(index){
            this.search_key = '';
            this.products[this.selected_product_index].products_loading = false
            this.selected_product_index = null;
        },
    },
    mounted(){
        this.currency = this.loggedInUser.currency.symbol;
        if(this.edit_product == true && this.single_product == false){
            this.loadLeadProducts();
        }else if(this.edit_product == true && this.single_product == true){
            let edit_data  = this.edit_lead_products
            let selected_products = []
            edit_data.forEach(el =>{
                selected_products.push({
                    amount_inquired: el.amount_inquired,
                    price_quoted: el.price_quoted,
                    product_name: {
                        id : el.product_id,
                        name : el.product_name,
                    },
                    template_fields: el.template_details
                    // {
                    //     template_id: "",
                    //     template_name: "",
                    //     template_fields: el.template_fields
                    // }
                })
            })
            this.products_data = selected_products
        }
    },
    created() {
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        searchProuctName(){
            return debounce(this.searchProuctNameDebouncer, 500)
        },
    },
}
</script>
<style scoped>
    .btn-cancel-style {
        color: #E82828 !important;
        background-color: #fff;
        border: 1px solid #E82828
    }
    .btn-edit-delete-style {
        color: #E82828 !important;
        background-color: #fff;
        border: 1px solid #E82828;
        padding: 0px 0px !important;
        width: 60px !important;
        border-radius: 5px !important;
        font-size: 14px !important;
        line-height: 30px !important;
        text-transform: none !important;
        font-weight: 600 !important;
        cursor: pointer;
    }
    .btn-delete-style {
        color: #E82828 !important;
        background-color: #fff;
        border: 1px solid #E82828;
        width: 136px !important;
    }
    .btn-new-save {
        color: #fff;
        background-color: #1A9347;
    }
    .btn-edit-save {
        color: #fff;
        background-color: #1A9347 !important;
        border: 1px solid #1A9347 !important;
        padding: 0px 0px !important;
        width: 60px !important;
        border-radius: 5px !important;
        font-size: 14px !important;
        line-height: 30px !important;
        text-transform: none !important;
        font-weight: 600 !important;
        cursor: pointer;
    }
    .bg-color{
        background-color: #cce3fc;
        color:#0475f3 !important;
        padding: left 0px !important;
    }
    .disableBtn{
        background-color: rgb(133, 133, 133, 0.6) !important;
        border: none !important;
        pointer-events: none !important;
        color: #fff !important;
    }
    .product-box{
        width: 100%;
        height: 100%;
        padding: 5px 14px 25px 14px;
        object-fit: contain;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.16);
        background-color: #fff;
        border-radius: 8px !important;
    }
    .minus-icon {
        width: 35px;
        height: 35px;
        padding: 6px 0 4.6px 7px;
        border-radius: 8px !important;
        box-shadow: 0 3px 6px 0 rgba(0, 68, 139, 0.31);
        background-color: #fff;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        font-size: 14px !important;
        font-weight: 600;
        color: #303031 !important;
    }
    .input-field::placeholder{
        color: #4e5764 !important;
		display: inline-block;
		margin-bottom: 7px !important;
		padding-top: 5px;
		padding-left: 5px !important;
		width: 100%;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
        font-weight: 400 !important;
    }
    .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 90px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Leads/NewAddProduct.vue